<script lang="ts">
  import { Card, List } from '$shared/components';
  import type { PrintData } from '$shared/models/PrintData';
import { ListStyle } from '$shared/constants/ListStyle';

  interface Props {
    data: PrintData;
  }

  let { data }: Props = $props();
</script>

<div class="providedinfo-section">
  <div class="title">Provided info</div>
  <div class="meta">{''}</div>
  <div class="list">
    <Card nospace>
      <List
        problems={data.providedInfo?.__meta?.problems}
        style={ListStyle.Compact}
        list={data.providedInfo}
      />
    </Card>
  </div>
</div>

<style>
  .title {
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    color: var(--grey-black);
  }
  .meta {
    display: flex;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    min-height: 18px;
    color: var(--grey-medium);
    margin-top: 16px;
  }
  .list {
    margin-top: 8px;
  }
</style>
